<template>
    <div class="calender">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>시간</th>
                    <th>일</th>
                    <th>월</th>
                    <th>화</th>
                    <th>수</th>
                    <th>목</th>
                    <th>금</th>
                    <th>토</th>
                </tr>
            </thead>
            <tbody class="table-body">
                <tr
                    v-for="time in times"
                    :key="time"
                >
                    <td>{{time}}</td>
                    <td>{{checkWeek(timetable[time], 0)}}</td>
                    <td>{{checkWeek(timetable[time], 1)}}</td>
                    <td>{{checkWeek(timetable[time], 2)}}</td>
                    <td>{{checkWeek(timetable[time], 3)}}</td>
                    <td>{{checkWeek(timetable[time], 4)}}</td>
                    <td>{{checkWeek(timetable[time], 5)}}</td>
                    <td>{{checkWeek(timetable[time], 6)}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ["timetable", "times"],
    methods: {
        checkWeek: function ( timetable_row, week ) {
            for ( const program of timetable_row ) {
                if (program.date_week === week ){
                    return program.title;
                }
            }
            return '';
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
$border-color: #999999;

.calender {
    max-width: 800px;
    margin: 0 auto;
}
.table {
    max-width: 800px;
    border: 1px solid $border-color;
    border-spacing: 0;
}
.table-head {
    border-bottom: 1px solid $border-color;
    background-color: $pantone-n;
    tr > th {
        padding: 5px 20px;
    }
    tr > th:not(:last-child) {
        border-right: 1px solid $border-color;
    }
}
.table-body {
    font-size: 14px;
    tr > td {
        width: 100px;
        padding: 5px 0;
    }
    tr> td:first-child {
        background-color: transparentize($color: $pantone-n, $amount: 0.8);
    }
    tr > td:not(:last-child) {
        border-right: 1px solid $border-color;
    }
    tr:not(:last-child) > td {
        border-bottom: 1px dotted $border-color;
    }
}
</style>
